import React, { useState } from 'react'

import { Button, message, Space } from 'antd';

import './Layout.css'
import Navbar from './Navbar';
import SideBar from './SideBar';


interface Props {
    children: React.ReactNode
}

const Layout = ({children}:Props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [open, setOpen] = useState<boolean>(false);

  return (
    <div className='Layout-component'>
        {contextHolder}


        <Navbar setOpen={setOpen} />

        <SideBar open={open} setOpen={setOpen} ></SideBar>
        <div className={'Layout-children'}>
            {children}
        </div>
        
    </div>
  )
}

export default Layout